import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import './header.css';

export default function Header(props) {
   const [isMenuOpen, setIsMenuOpen] = useState(false);

   const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen);
   };

   const scrollToAbout = () => {
      const element = document.getElementById("about");
      if (element) {
         element.scrollIntoView({ behavior: 'smooth' });
      }
   };

   return (
      <>
         <nav className='flex justify-between items-center text-white px-4 pt-6
         md:px-20 md:p-6 bg-[var(--bg-header)] sticky top-0 z-40'>
            <span className=' text-3xl md:text-5xl font-bold tracking-wide'>
               Portfolio
            </span>

     
            <button className='md:hidden text-white p-2' onClick={toggleMenu}>
               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0  0 25 25 ">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                     d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
                  />
               </svg>
            </button>

            <ul className={`absolute left-0 right-0 top-[80px] mx-4 py-4 bg-black rounded-xl 
               bg-opacity-90 md:bg-transparent md:static md:flex md:gap-16 text-xl
               transition-all duration-300 ${isMenuOpen ? 'block' : 'hidden'} md:block`}> <ul />

               <li className='text-md transition-all duration-300 p-3 md:p-0 hover:bg-gray-700 md:hover:bg-transparent'>
                  <Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link>
               </li>

               <li className='text-md transition-all duration-300 p-3 md:p-0 hover:bg-gray-700 md:hover:bg-transparent cursor-pointer'>
                  <a onClick={() => { scrollToAbout(); setIsMenuOpen(false); }}>About</a>
               </li>

               <li className='text-md transition-all duration-300 p-3 md:p-0 hover:bg-gray-700 md:hover:bg-transparent'>
                  <Link to="/experience" onClick={() => setIsMenuOpen(false)}>Experience</Link>
               </li>

               <li className='text-md transition-all duration-300 p-3 md:p-0 hover:bg-gray-700 md:hover:bg-transparent'>
                  <Link to="/projects" onClick={() => setIsMenuOpen(false)}>Projects</Link>
               </li>

               <li className='text-md transition-all duration-300 p-3 md:p-0 hover:bg-gray-700 md:hover:bg-transparent'>
                  <Link to="/contact" onClick={() => setIsMenuOpen(false)}>Contact</Link>
               </li>
            </ul>
         </nav>
         <Outlet />
      </>
   );
}
